module.exports = __webpack_public_path__ + "img/mi-afspraak-maken.7a8e3a24.svg";